import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["externalSection", "internalSection"]

  connect() {
    // Initialize based on current state
    this.toggleContentType()
  }

  toggleContentType() {
    const selectedType = document.querySelector('input[name="content_type"]:checked')?.value
    
    if (selectedType === 'external') {
      this.showExternal()
    } else {
      this.showInternal()
    }
  }

  showExternal() {
    this.externalSectionTarget.style.display = 'block'
    this.internalSectionTarget.style.display = 'none'
    
    // Always clear internal content when switching to external
    const contentField = this.internalSectionTarget.querySelector('textarea')
    if (contentField) {
      contentField.value = ''
    }
  }

  showInternal() {
    this.externalSectionTarget.style.display = 'none'
    this.internalSectionTarget.style.display = 'block'
    
    // Always clear URL when switching to internal
    const urlField = this.externalSectionTarget.querySelector('input[type="url"]')
    if (urlField) {
      urlField.value = ''
    }
  }
} 